export function isNotDefined(source: unknown): boolean {
  return source === undefined || source === null
}
